module.exports = __webpack_public_path__ + "static/rrImage-fd2d6715dfd31276224e3615d42a262c.png";